import {
    SET_FORM_DATA, SHOW_APP_BAR, SET_REGISTRATION_DATA, IS_LOADING, SET_ALERT_DIALOG_CONTENT
} from "../types";
import api from "../../utils/api";
import {PAYMENT_TYPE_TEACHER_HOUR} from "../../utils/constants";
import moment from "moment";

export const registrationActions = (props) => {

  const registerTuitionFees = (data) => {
      api.qmsService
          .post(`/services/qms/register/course`, data)
          .then(res => {
              //TODO: Show dialog to update
              console.log("register courses successfully");
              props.dispatch({ type: SET_REGISTRATION_DATA, courses: res.data })
          })
          .catch(error => {
              // props.dispatch({ type: IS_LOADING, data: false });
              // props.dispatch({
              //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
              //     dialog: {
              //       dialogTitle: "Somthing went wrong!",
              //       dialogContent: error?.data?.error?.message
              //     },
              //     show: true
              //   }
              // });
          });
  };
  return {
    setFormData: (data) => {
      props.dispatch({ type: SET_FORM_DATA, data })
    },
    registerStudent: (data) => {
        props.dispatch({ type: IS_LOADING, data: true });
        const payload = JSON.parse(JSON.stringify(data));
        payload.phoneNo = "60" + payload.phoneNo;
        payload.emergencyContactPhoneNo = payload.emergencyContactPhoneNo !== "" ? "60" + payload.emergencyContactPhoneNo : "";
        for (let i = 0; i < payload.tuitionCourse.length; i++){
            payload.tuitionCourse[i].fee =  payload.tuitionCourse[i].fee * 100; //convert to sen
            payload.tuitionCourse[i].effectiveDate = moment(payload.tuitionCourse[i].effectiveDate).format('MM-YYYY');
        }
        payload.enrolmentDate = moment(payload.enrolmentDate).format('MM-YYYY');
        api.qmsService
            .post(`/services/qms/student/register`, payload)
            .then(res => {
                props.dispatch({ type: IS_LOADING, data: false });
                props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                    title: "Thank you",
                    content: "Registration has been completed"
                });
                // props.dispatch({ type: SET_REGISTRATION_DATA, courses: res.data })
            })
            .catch(error => {
                console.log(error);
                if (error.status === 422){
                    const errorKeys = Object.keys(error.data.error.message);
                    props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                        title: "Oops",
                        content: error.data.error.message[errorKeys[0]]
                    });
                    props.dispatch({ type: IS_LOADING, data: false });
                    return;
                }

                props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                        title: "Oops",
                        content: error.data.error.message
                });
                props.dispatch({ type: IS_LOADING, data: false });
                // props.dispatch({ type: IS_LOADING, data: false });
                // props.dispatch({
                //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                //     dialog: {
                //       dialogTitle: "Somthing went wrong!",
                //       dialogContent: error?.data?.error?.message
                //     },
                //     show: true
                //   }
                // });
            });
    },

    registerNewCourse: (data, resetForm) => {
        props.dispatch({ type: IS_LOADING, data: true });
        api.qmsService
          .post(`/services/qms/course/register`, data)
          .then(res => {
             resetForm();
             props.dispatch({ type: IS_LOADING, data: false });
             props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Thank you",
                  content: "Registration has been completed"
             });

            // props.dispatch({ type: SET_REGISTRATION_DATA, courses: res.data })
          })
          .catch(error => {
              props.dispatch({ type: IS_LOADING, data: false });
              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Oops",
                  content: error.data.error.message
              });
            // props.dispatch({ type: IS_LOADING, data: false });
            // props.dispatch({
            //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
            //     dialog: {
            //       dialogTitle: "Somthing went wrong!",
            //       dialogContent: error?.data?.error?.message
            //     },
            //     show: true
            //   }
            // });
          });
    },

    updateStudentInfo: (data) => {
      props.dispatch({ type: IS_LOADING, data: true });
      const payload = JSON.parse(JSON.stringify(data));
      payload.phoneNo = "60" + payload.phoneNo;
      payload.emergencyContactPhoneNo = payload.emergencyContactPhoneNo !== "" ? "60" + payload.emergencyContactPhoneNo : "";
      for (let i = 0; i < payload.tuitionCourse.length; i++){
          payload.tuitionCourse[i].fee =  payload.tuitionCourse[i].fee * 100; //convert to sen
          payload.tuitionCourse[i].effectiveDate = moment(payload.tuitionCourse[i].effectiveDate).format('MM-YYYY');
      }
      if (payload.enrolmentDate) {
          payload.enrolmentDate = moment(payload.enrolmentDate).format('MM-YYYY');
      } else {
          payload.enrolmentDate = null;
      }
      api.qmsService
          .post(`/services/qms/student/update`, payload)
          .then(res => {
              props.dispatch({ type: IS_LOADING, data: false });
              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Thank you",
                  content: "Info update has been completed"
              });
              // props.dispatch({ type: SET_REGISTRATION_DATA, courses: res.data })
          })
          .catch(error => {
              console.log(error);
              if (error.status === 422){
                  const errorKeys = Object.keys(error.data.error.message);
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message[errorKeys[0]]
                  });
                  props.dispatch({ type: IS_LOADING, data: false });
                  return;
              }

              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Oops",
                  content: error.data.error.message
              });
              props.dispatch({ type: IS_LOADING, data: false });
              // props.dispatch({ type: IS_LOADING, data: false });
              // props.dispatch({
              //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
              //     dialog: {
              //       dialogTitle: "Somthing went wrong!",
              //       dialogContent: error?.data?.error?.message
              //     },
              //     show: true
              //   }
              // });
          });
    },

    updateStudentStatus: (data, history) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .post(`/services/qms/student/status`, data)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Thank you",
                      content: `This student has been ${data.status}`
                  });
                  history.push("/student/management");
                  // props.dispatch({ type: SET_REGISTRATION_DATA, courses: res.data })
              })
              .catch(error => {
                  console.log(error);
                  if (error.status === 422){
                      const errorKeys = Object.keys(error.data.error.message);
                      props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                          title: "Oops",
                          content: error.data.error.message[errorKeys[0]]
                      });
                      props.dispatch({ type: IS_LOADING, data: false });
                      return;
                  }

                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
                  props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({ type: IS_LOADING, data: false });
                  // props.dispatch({
                  //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                  //     dialog: {
                  //       dialogTitle: "Somthing went wrong!",
                  //       dialogContent: error?.data?.error?.message
                  //     },
                  //     show: true
                  //   }
                  // });
              });
    },



    cancelCourseSubscription: (subscriptionId, month, removeItem) => {
      if (subscriptionId == null || subscriptionId === "" || subscriptionId === 0) return;
      props.dispatch({ type: IS_LOADING, data: true });
      api.qmsService
          .post(`/services/qms/student/course/cancel`, {id : subscriptionId, month})
          .then(res => {
              //TODO: Show dialog to update
              props.dispatch({ type: IS_LOADING, data: false });
              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Thank you",
                  content: "You've cancelled the subscription"
              });
              if (removeItem){
                  removeItem();
              }
          })
          .catch(error => {
              props.dispatch({ type: IS_LOADING, data: false });
              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Oops",
                  content: error.data.error.message
              });
          });
    },

    cancelMiscSubscription: (subscriptionId, month, removeItem) => {
      if (subscriptionId == null || subscriptionId === "" || subscriptionId === 0) return;
      props.dispatch({ type: IS_LOADING, data: true });
      api.qmsService
          .post(`/services/qms/student/misc/cancel`, {id : subscriptionId, month})
          .then(res => {
              //TODO: Show dialog to update
              props.dispatch({ type: IS_LOADING, data: false });
              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Thank you",
                  content: "You've cancelled the subscription"
              });
              if (removeItem) { removeItem(); }
          })
          .catch(error => {
              props.dispatch({ type: IS_LOADING, data: false });
              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Oops",
                  content: error.data.error.message
              });
          });
    },

    getAllCourses:  () => {
        api.qmsService
            .get(`/services/qms/courses`)
            .then(res => {
                //TODO: Show dialog to update
                console.log("get courses successfully");
                props.dispatch({ type: SET_REGISTRATION_DATA, data: { courses: res.data } })
            })
            .catch(error => {
                // props.dispatch({ type: IS_LOADING, data: false });
                // props.dispatch({
                //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
                //     dialog: {
                //       dialogTitle: "Somthing went wrong!",
                //       dialogContent: error?.data?.error?.message
                //     },
                //     show: true
                //   }
                // });testing
            });
    },
    getAllProgramLvl:  () => {
      api.qmsService
          .get(`/services/qms/programLvl`)
          .then(res => {
              //TODO: Show dialog to update
              console.log(res.data);
              props.dispatch({ type: SET_REGISTRATION_DATA, data: {programLvl: res.data} })
              console.log("get program lvls successfully");
          })
          .catch(error => {
              // props.dispatch({ type: IS_LOADING, data: false });
              // props.dispatch({
              //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
              //     dialog: {
              //       dialogTitle: "Somthing went wrong!",
              //       dialogContent: error?.data?.error?.message
              //     },
              //     show: true
              //   }
              // });
          });
    },
    registerTeacher: (data, resetForm) => {
        props.dispatch({ type: IS_LOADING, data: true });
        const payload = JSON.parse(JSON.stringify(data));
        payload.phoneNo = "60" + payload.phoneNo;
        console.log(payload.paymentType);
        if (payload.paymentType === PAYMENT_TYPE_TEACHER_HOUR){
            payload.paymentRate = payload.paymentRate * 100; //convert to sen
        }
        for (let i = 0; i < payload.tuitionCourse.length; i++){
            payload.tuitionCourse[i].fee =  payload.tuitionCourse[i].fee * 100; //convert to sen
        }
        api.qmsService
          .post(`/services/qms/teacher/register`, payload)
          .then(res => {
              props.dispatch({ type: IS_LOADING, data: false });
              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Thank you",
                  content: "Registration has been completed"
              });
              resetForm();
          })
          .catch(error => {
              props.dispatch({ type: IS_LOADING, data: false });
              props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                  title: "Oops",
                  content: error.data.error.message
              });
              // props.dispatch({ type: IS_LOADING, data: false });
              // props.dispatch({
              //   type: SET_VERIFY_CODE_FAILURE_DIALOG, data: {
              //     dialog: {
              //       dialogTitle: "Somthing went wrong!",
              //       dialogContent: error?.data?.error?.message
              //     },
              //     show: true
              //   }
              // });
          });
      },
      updateTeacherInfo: (data, history) => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = JSON.parse(JSON.stringify(data));

          payload.phoneNo = "60" + payload.phoneNo;
          if (payload.paymentType === PAYMENT_TYPE_TEACHER_HOUR){
              payload.paymentRate = payload.paymentRate * 100; //convert to sen
          }
          for (let i = 0; i < payload.tuitionCourse.length; i++){
              payload.tuitionCourse[i].fee =  payload.tuitionCourse[i].fee * 100; //convert to sen
          }
          api.qmsService
              .post(`/services/qms/teacher/update`, payload)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Thank you",
                      content: "Info update has been completed"
                  });
                  history.push("/teacher/management");
                  // props.dispatch({ type: SET_REGISTRATION_DATA, courses: res.data })
              })
              .catch(error => {
                  console.log(error);
                  if (error.status === 422){
                      const errorKeys = Object.keys(error.data.error.message);
                      props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                          title: "Oops",
                          content: error.data.error.message[errorKeys[0]]
                      });
                      props.dispatch({ type: IS_LOADING, data: false });
                      return;
                  }

                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
                  props.dispatch({ type: IS_LOADING, data: false });
              });
      },

      cancelTuitionCourse: (tuitionId) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .post(`/services/qms/teacher/tuition/cancel`, {id : tuitionId})
              .then(res => {
                  //TODO: Show dialog to update
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Thank you",
                      content: "You've cancelled the course"
                  });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },
  }
};
